import { ArrowIconOutline } from "src/components/Icons";
import { Button } from "src/components";
import { TooltipText } from "src/components/TooltipInfo/styles";
import styled, { css } from "styled-components";

export const Container = styled.div`
  background: ${(props) => props.theme.colors.disabledMeatballItem};
  padding: 3px 8px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CheckboxButton = styled(Button)`
  cursor: ${(props) => (props.isLocked ? 'default' : 'pointer')};
  height: 20px;
  width: 20px;
  background-color: transparent;
  padding: 2px 0;

  ${({ isLocked }) => isLocked ? css`
    pointer-events: none;
    opacity: 0.5;
  ` : ''}

  &:hover {
    background-color: transparent;
    color: transparent;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LockedBadge = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 1px 6px;
  /* constrat acompanha o Title da linha: o secondary tem 1.08:1 sobre o fundo
     do item no tema light, contra 5.38:1 do constrat */
  border: 1px solid ${(props) => props.theme.colors.constrat};
  border-radius: 4px;
  color: ${(props) => props.theme.colors.constrat};
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;

  &:hover > span {
    visibility: visible;
    opacity: 1;
  }
`;

/* Reusa o balão do TooltipInfo para herdar os tokens de tema do design system.
   O white-space precisa ser reposto: sem ele o balão herda o nowrap do selo,
   ignora o max-width e vaza para fora da coluna de configuração */
export const LockedBadgeTooltip = styled(TooltipText)`
  white-space: normal;
`;

export const Square = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 2.28571px;
  border: 1px solid
    ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : props.theme.colors.text.default};
  display: inline-block;
  background: ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : 'transparent'};
  box-sizing: border-box;
  position: relative;

  ${(props) =>
    props.isChecked
      ? `
    :before,
  :after {
    content: "";
    position: absolute;
    display: block;
    height: 9px;
    width: 1.6px;
    background: ${props.theme.colors.backgroundColorPage};
  }

  :after {
    transform: rotate(45deg);
    left: 8px;
    top: 2px;
  }
  :before {
    height: 6px;
    transform: rotate(-45deg);
    left: 4px;
    top: 5px;
  }
  `
      : ""}
`;

export const Title = styled.span`
  color: ${(props) => props.theme.colors.constrat};
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Icon = styled(ArrowIconOutline)`
  width: 26px;
  height: 26px;
  transform: rotate(${(props) => (props.isOpen ? "180deg" : "0deg")});
  transition: transform 0.3s;
  color: ${(props) => props.theme.colors.secondary};
  cursor: pointer;
`;

export const ChildrenContainer = styled.div`
  margin-top: 10px;
  font-size: 14px;
`;